import React from "react";
import OrdenFormMobile from "./OrdenFormMobile";
import OrdenFormDesktop from "./OrdenFormDesktop";
import { useIsMobile } from "../../hooks/useDeviceType";

export default function OrdenForm({ orden, onClose, onSaved, agendamientoInicial }) {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <OrdenFormMobile orden={orden} onClose={onClose} onSaved={onSaved} agendamientoInicial={agendamientoInicial} />;
  }
  
  return <OrdenFormDesktop orden={orden} onClose={onClose} onSaved={onSaved} agendamientoInicial={agendamientoInicial} />;
}
